import { ChangeDetectionStrategy, Component } from '@angular/core';
import { InStoreComponent } from './in-store/in-store.component';
import { CompaniesComponent } from './companies/companies.component';
import { DualPillarComponent } from './dual-pillar/dual-pillar.component';
import { PlatformTeaserComponent } from './platform-teaser/platform-teaser.component';
import { IndustriesComponent } from './industries/industries.component';
import { FeaturedCaseStudiesComponent } from './featured-case-studies/featured-case-studies.component';
import { ExpertiseComponent } from './expertise/expertise.component';
import { SubscribeComponent } from '../subscribe/subscribe.component';
import { TryDemoComponent } from '../try-demo/try-demo.component';

@Component({
  selector: 'app-main-page',
  templateUrl: './main-page.component.html',
  styleUrls: ['./main-page.component.scss'],
  imports: [
    InStoreComponent,
    CompaniesComponent,
    DualPillarComponent,
    PlatformTeaserComponent,
    IndustriesComponent,
    FeaturedCaseStudiesComponent,
    ExpertiseComponent,
    SubscribeComponent,
    TryDemoComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent {}
